import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Calendar"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-calendar',
    templateUrl: './icon-calendar.component.html',
    styleUrls: ['./icon-calendar.component.scss'],
    standalone: false
})
export class IconCalendarComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
